// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"58ac5270","865":"8759c112"}[chunkId] + ".chunk.js";
};